import { render, staticRenderFns } from "./comment_box.vue?vue&type=template&id=6c76c8c2&scoped=true&"
import script from "./comment_box.vue?vue&type=script&lang=js&"
export * from "./comment_box.vue?vue&type=script&lang=js&"
import style0 from "./comment_box.vue?vue&type=style&index=0&id=6c76c8c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c76c8c2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/oem/work/Rails/tosdere_erp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('6c76c8c2', component.options)
    } else {
      api.reload('6c76c8c2', component.options)
    }
    module.hot.accept("./comment_box.vue?vue&type=template&id=6c76c8c2&scoped=true&", function () {
      api.rerender('6c76c8c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/packs/components/utils/comment_box.vue"
export default component.exports